<template>
    <div>
    
        <CRow class="justify-content-center align-items-center" style="width:100%;margin:0 auto" v-if="First === true">
    
         
            <div class="m-0 text-center mt-3">
                <img style="max-width: 80%" src="../assets/img/RegisterImg.png" />
                <br />
                <img style="max-width: 50px" src="../assets/img/slider-blue.png" />
                <br />
                <h5 class="custom-title-app poppin-font mt-2">Explore Skills and Services</h5>
    
                <p class="custom-sub-app poppin-font">Begin your journey by exploring a vast <br /> range of skills and services offered by our <br /> talented freelancers.
                </p>
    
                <div style="width:80%; margin: 0 auto">
                    <CButton type="button" class="button-border-blue text-white" block @click="GoToSecond()">Continue</CButton>
                </div>
                <br /><br /><br />
            </div>
            <br />
        </CRow>
    
        <CRow class="justify-content-center align-items-center" style="width:100%;margin:0 auto" v-if="Second === true">
            <div class="m-0 text-center mt-3">
                <img style="max-width: 80%" src="../assets/img/RegisterApp2.png" />
                <br />
                <img style="max-width: 50px" src="../assets/img/slider-blue.png" />
                <br />
                <h5 class="custom-title-app poppin-font mt-2">Identify the Perfect Match</h5>
    
                <p class="custom-sub-app poppin-font">We've made it easy for you to identify the <br /> perfect match for your project. Explore and <br /> compare expertise to find the ideal freelancer. <br /> talented freelancers.
                </p>
    
                <div style="width:80%; margin: 0 auto">
                    <CButton type="button" class="button-border-blue text-white" block @click="GoToThird()">Continue</CButton>
                </div>
                <br /><br /><br />
            </div>
            <br />
        </CRow>
    
        <CRow class="justify-content-center align-items-center" style="width:100%;margin:0 auto" v-if="Third === true">
            <div class="m-0 text-center mt-3">
                <img style="max-width: 80%" src="../assets/img/RegisterApp3.png" />
                <br />
                <img style="max-width: 50px" src="../assets/img/slider-blue.png" />
                <br />
                <h5 class="custom-title-app poppin-font mt-2">Start Collaborating</h5>
    
                <p class="custom-sub-app poppin-font"> Once you've found the right fit, it's time to <br /> start collaborating. Connect, discuss your <br /> project, and get the work rolling </p>
    
                <div style="width:80%; margin: 0 auto">
                    <CButton type="button" class="button-border-blue text-white" block @click="GoToRegister()">Start</CButton>
                </div>
                <br /><br /><br />
            </div>
            <br />
        </CRow>
    </div>
</template>



<script>
import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);
export default ({
    setup() {

    },
    data() {
        return {
            First: true,
            Second: false,
            Third: false
        }

    },
    methods: {
        GoToSecond() {
            this.First = false;
            this.Second = true;
            this.Third = false;
        },
        GoToThird() {

            this.Second = false;
            this.First = false;
            this.Third = true;

        },
        GoToRegister()
        {
            this.$router.push("/RegisterHomepage");
        }
    }
})
</script>
  